import { Link, useParams } from 'react-router-dom';
import { useProject } from '../../data/queries/use-project';
import { SolConversation } from './SolConversation';

/**
 * `/projects/:projectId/sol` — the ROUTE, and nothing else. M9 / S09-04.
 *
 * **THE ONLY `useParams()` IN THE SOL FEATURE, DELIBERATELY** (D-04-2). Every
 * reusable Sol component takes Project context as props, so a future global
 * `/sol` reuses the same architecture by mounting `SolConversation` with
 * `currentProjectId = null`. A component that read the route itself could not
 * be mounted anywhere the route did not exist.
 *
 * The id in the URL grants nothing: `useProject` is filtered by RLS, and
 * `sol-ask` resolves scope from the caller's own token rather than from a path.
 * Reading the Project here is for the CONTEXT LINE only — its name — and Sol
 * answers perfectly well while that read is still in flight.
 */
export function AskSolScreen() {
  const { projectId, conversationId } = useParams<{ projectId: string; conversationId: string }>();
  const { project } = useProject(projectId);

  return (
    <main className="cl-screen sol-screen">
      <p className="project-home-back">
        <Link className="cl-link" to={projectId ? `/projects/${projectId}` : '/'}>
          ‹ Project
        </Link>
      </p>

      <SolConversation
        currentProjectId={projectId ?? null}
        // **NEVER `project.name ?? project.id`.** A Project whose row has not
        // loaded yet simply has no context line; a UUID would be worse than
        // nothing, and this is the exact expression the UUID rule bans.
        currentProjectName={project?.name ?? null}
        // An earlier Project-origin conversation to reopen (M11 / D-041), or
        // null. An identifier, not a permission — see `GlobalSolScreen`.
        openConversationId={conversationId ?? null}
      />
    </main>
  );
}
